import { Alert, Button, Grid } from "@mui/material"
import { useContext, useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { MAX } from "../../services/validation/personal-and-contact-details-form/CardNameValidator"
import { Action, ActionType } from "../../store/signup/SignupReducer"
import { PersonalDetailMyInfo } from "../../store/signup/SignupState"
import { useSignupStore } from "../../store/signup/UserSignupStore"
import TabProps from "../TabProps/TabProps"
import { CardNameInputField, DateOfBirthInputField, EducationSelectField, EmailInputField, GenderInputField, MaritalStatusSelectField, MobileNumberInputField, NricInputField, NricNameInputField, RaceSelectField, ResidentialStatusSelectField } from "./FormFields/FormFields"
import { Option } from "../../services/ntuc/userService/staticData"
import { StaticDataContext } from "../../views/signup-flow/SignupFormPage/SignupFormPage"
import { saveUserMembershipInfo } from "../../services/ntuc/memberService/membershipSignup"
import { Status } from "../../services/ntuc/Model"
import moment from "moment"
import { SignupRoute } from "../../views/signup-flow/SignupFlow/SignupFlow"
import { updateMembershipOAData, UserMembershipResponse } from "../../services/ntuc/memberService/oaMembership"
import { DialogButtonAction, useAlertErrorHandler, useDialogErrorHandler } from "../../hooks/ErrorHandler"
import { postMembershipDraft, postMembershipDraftMembership } from "../../services/ntuc/memberService/draft"
import ErrorDialog from "../Dialog/ErrorDialog"
import signupFormGenerator from "../../services/faker/fakeData"
import { searchParams } from "../../helpers/search-params"
import { ErrorCode } from "../../services/ntuc/applicationError"
import { useCookies } from "react-cookie"
import { AppCookies } from "../../helpers/cookies"
import { getUser } from "../../services/linkpass/user"
import { SaveAndContinueButton } from "../SaveAndContinueButton/SaveAndContinueButton"
import { getSignupRequest } from "../../helpers/SignupUtils"
import PersonalDetailsValidator, { PersonalDetailsFormValidation, processMobileNumber, validateCardName, validateGender, validateName } from "../../services/validation/personal-and-contact-details-form/PersonalDetailsValidator"
import { trackSignUpStep } from "../../helpers/gtm"

function PersonalAndContactDetails(props: TabProps) {
    const { changeTab, onNavigateTo } = props
    const { t } = useTranslation(`common`)
    const { t: tMyInfo } = useTranslation(`myinfo`)
    const setCookie = useCookies()[1]

    const [nricErrorMessage, setNricErrorMessage] = useState<string | undefined>()
    const [nameErrorMessage, setNameErrorMessage] = useState<string | undefined>()
    const [cardNameErrorMessage, setCardNameErrorMessage] = useState<string | undefined>()
    const [dateOfBirthErrorMessage, setDateOfBirthErrorMessage] = useState<string | undefined>()
    const [genderErrorMessage, setGenderErrorMessage] = useState<string | undefined>()
    const [mobileNumberErrorMessage, setMobileNumbeErrorMessage] = useState<string | undefined>()
    const [emailErrorMessage, setEmailErrorMessage] = useState<string | undefined>()
    const [raceErrorMessage, setRaceErrorMessage] = useState<string | undefined>()
    const [maritalStatusErrorMessage, setMaritalStatusErrorMessage] = useState<string | undefined>()
    const [residentialStatusErrorMessage, setResidentialStatusErrorMessage] = useState<string | undefined>()
    const [validEducationalErrirStatus, setValidEducationalErrorStatus] = useState<string | undefined>()
    const [isLoading, setIsLoading] = useState<boolean>(false)

    const [alert, alertErrorHandler] = useAlertErrorHandler()

    const [dialog, dialogErrorHandler, closeHandler] = useDialogErrorHandler(
        {
            content: ``,
            title: ``,
            display: false,
        },
    )

    const [state, dispatch] = useSignupStore()
    // const [form, setForm] = useState<PersonalDetail>(state.personalDetail)
    const [myInfoSuccess, setMyInfoSuccess] = useState(state.disabledFields.myInfo)
    const [disabledFields, setDisabledFields] = useState<PersonalDetailMyInfo>(state.disabledFields.personalDetailMyInfo)
    const statictData = useContext(StaticDataContext)

    enum ValidMaritalStatus {
        MARRIED = `M`,
        SINGLE = `S`,
        SEPARATED = `P`,
        DIVORCED = `D`,
        WIDOWED = `W`,
    }

    enum RaceCodes {
        CHINESE = `CN`,
        MALAY = `MY`,
        INDIAN = `IN`,
        EURASIAN = `EU`,
        OTHERS = `OT`,
    }

    useEffect(() => {
        // MyInfo Callback Error
        const error = searchParams.error
        const errorDescription = searchParams[`error-description`]

        if (error && errorDescription) {
            setMyInfoSuccess(false)
            alertErrorHandler({
                error: error,
                errorDescription: errorDescription,
                errorCode: ErrorCode.MYINFO_ERROR,
            })
        }
    }, [])

    useEffect(() => {
        // MyInfo Callback /w invalid data
        if (state.myInfo.mandatoryFieldsFilled === false) {
            setMyInfoSuccess(false)
            alertErrorHandler({
                error: ``,
                errorDescription: tMyInfo(`errors.partial_data`),
                errorCode: ErrorCode.MYINFO_ERROR,
            })
        }
    }, [])

    useEffect(() => {
        switch (state.personalDetail.maritalStatus.code) {
            case ValidMaritalStatus.SINGLE:
            case ValidMaritalStatus.MARRIED:
            case ValidMaritalStatus.SEPARATED:
            case ValidMaritalStatus.DIVORCED:
            case ValidMaritalStatus.WIDOWED:
                break
            default:
                dispatch({
                    type: ActionType.ADD_PERSONAL_DETAILS,
                    value: {
                        ...state.personalDetail,
                        maritalStatus: { code: ``, value: `` },
                    },
                })
                setDisabledFields((state) => ({
                    ...state,
                    maritalStatus: false,
                }))
                break
        }

        if (state.personalDetail.nric && state.personalDetail.saved == true) {
            setDisabledFields((state) => ({
                ...state,
                nric: true,
            }))
        }
    }, [state.personalDetail.maritalStatus.code, state.personalDetail.nric])

    useEffect(() => {
        // Check if the data given by MyInfo is on the static list. If not, set to Others
        if (statictData && state.personalDetail.race.code !== ``) {
            let valid = false

            statictData.race.forEach((value: Option) => {
                if (value.code === state.personalDetail.race.code) {
                    valid = true
                }
            })

            if (!valid) {
                const otherRace = statictData.race.find((element: Option) => {
                    return element.code === RaceCodes.OTHERS
                })

                if (otherRace) {
                    dispatch({
                        type: ActionType.ADD_PERSONAL_DETAILS,
                        value: {
                            ...state.personalDetail,
                            race: otherRace,
                        },
                    })
                }
            }
        }

    }, [statictData?.race, state.personalDetail.race])

    useEffect(() => {
        if (window.myNtucConfig.authToken) {
            getUser()
                .then(response => response.data)
                .then(user => {
                    dispatch({
                        type: ActionType.ADD_PERSONAL_DETAILS,
                        value: {
                            ...state.personalDetail,
                            mobileNumber: user.phone_number,
                            email: user.email.toLocaleLowerCase(),
                        },
                    })
                    setDisabledFields((fields) => ({
                        ...fields,
                        email: true,
                        mobileNumber: true,
                    }))
                })
        }
    }, [])

    const saveForm = () => {
        const request = getSignupRequest(state)

        saveUserMembershipInfo(request, state.membershipId)
            .then(response => {
                if (response?.metadata.status === Status.SUCCESS) {
                    if (response?.content?.membership?.id) {
                        dispatch(saveMembershipId(response.content.membership.id))
                        setCookie(AppCookies.MEMBERSHIP_ID, response.content.membership.id)
                        sessionStorage.setItem(AppCookies.MEMBERSHIP_ID, response.content.membership.id.toString())

                        if (process.env.REACT_APP_NTUC_TARGET == `demo`) {
                            console.log(`DEMO ONLY\nemail: ${state.personalDetail.email}\nmembership: ${response.content.membership.id}\nExchange ID: ${response.content.user.exchangeId}`)
                            setCookie(AppCookies.DEMO_MEMBERSHIP_ID, response.content.membership.id)
                            setCookie(AppCookies.DEMO_MEMBERSHIP_EMAIL, state.personalDetail.email)
                        }
                    }

                    changeTab?.(`employment`)
                } else {
                    alertErrorHandler()
                }
            })
            .catch(error => {
                if (error.response) {
                    alertErrorHandler(error.response.data.content)
                    dialogErrorHandler(error.response.data.content)

                    if (error.response.data.content.membershipId !== undefined) {
                        dispatch(saveMembershipId(error.response.data.content.membershipId))
                    }
                } else if (error.errorCode in ErrorCode) {
                    alertErrorHandler(error)
                    dialogErrorHandler(error)
                }
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    const handleNavigateBack = () => {
        onNavigateTo(SignupRoute.Introduction)
    }

    const handleNavigateToHome = () => {
        if (window.myNtucConfig.homeUrl) {
            window.location.replace(window.myNtucConfig.homeUrl)
        }
    }

    const handleNavigateToLogin = () => {
        if (window.myNtucConfig.loginUrl) {
            window.location.replace(window.myNtucConfig.loginUrl)
        }
    }

    const handleSaveAndContinueClick = () => {
        PersonalDetailsValidator(state, statictData)
            .then(() => {
                trackSignUpStep(`ApplicantInformationForm`)
                setIsLoading(true)
                saveForm()
            })
            .catch(validationResult => {
                displayErrorMessages(validationResult)
            })
    }

    const displayErrorMessages = (validationResult: PersonalDetailsFormValidation) => {
        setNricErrorMessage(validationResult.nricValidationMessage)
        setNameErrorMessage(validationResult.nameValidationMessage)
        setCardNameErrorMessage(validationResult.cardNameValidationMessage)
        setDateOfBirthErrorMessage(validationResult.dateOfBirthValidationMessage)
        setGenderErrorMessage(validationResult.genderValidationMessage)
        setMobileNumbeErrorMessage(validationResult.mobileNumberValidationMessage)
        setEmailErrorMessage(validationResult.emailValidationMessage)
        setRaceErrorMessage(validationResult.raceValidationMessage)
        setMaritalStatusErrorMessage(validationResult.maritalStatusValidationMessage)
        setResidentialStatusErrorMessage(validationResult.residentialStatusValidationMessage)
        setValidEducationalErrorStatus(validationResult.educationalStatusValidationMessage)
    }

    const saveMembershipId = (id: number): Action => {
        return {
            type: ActionType.ADD_MEMBERSHIP_ID,
            value: id,
        }
    }

    const handleDialogClick = (action?: string): void => {
        switch (action) {
            case DialogButtonAction.BACK:
                return handleNavigateToHome()
            case DialogButtonAction.LOGIN:
                return handleNavigateToLogin()
            case DialogButtonAction.CANCEL:
                return closeHandler()
            case DialogButtonAction.DRAFT:
                return (window.myNtucConfig.authToken)
                    ? handleLoggedInRetrieveDraft()
                    : handleRetrieveDraft()
            case DialogButtonAction.CONTINUE:
                return handleContinue()
            default:
                break
        }
    }

    const NRIC = 4
    const handleRetrieveDraft = () => {
        postMembershipDraft({
            nric: state.personalDetail.nric.slice(-NRIC),
            dob: moment(state.personalDetail.dateOfBirth).format(`YYYY-MM-DD`),
        })
            .then(response => response.data.content)
            .then(draft => {
                dispatchDraft(draft)
                closeHandler()
            })
            .catch(error => {
                alertErrorHandler(error.response.data.content)
                dialogErrorHandler(error.response.data.content)
            })
    }

    const handleLoggedInRetrieveDraft = () => {
        postMembershipDraftMembership({
            nric: state.personalDetail.nric,
            dob: moment(state.personalDetail.dateOfBirth).format(`YYYY-MM-DD`),
        })
            .then(response => response.data.content)
            .then(draft => {
                dispatchDraft(draft)
                closeHandler()
            })
            .catch(error => {
                alertErrorHandler(error.response.data.content)
                dialogErrorHandler(error.response.data.content)
            })
    }

    const handleContinue = () => {
        if (state.membershipId) {
            updateMembershipOAData(
                getSignupRequest(state),
                state.membershipId,
            )
                .then(() => {
                    closeHandler()
                    return true
                }).catch((error) => {
                    closeHandler()
                    if (error.response) {
                        alertErrorHandler(error.response.data.content)
                        dialogErrorHandler(error.response.data.content)

                        if (error.response.data.content.membershipId !== undefined) {
                            dispatch(saveMembershipId(error.response.data.content.membershipId))
                        }
                    } else if (error.errorCode in ErrorCode) {
                        alertErrorHandler(error)
                        dialogErrorHandler(error)
                    }
                    return false
                })
                .then((success) => {
                    if (changeTab && success) {
                        changeTab(`employment`)
                    }
                })
        }
    }

    const dispatchDraft = (content: UserMembershipResponse) => {
        dispatch({
            type: ActionType.RETRIEVE_DRAFT,
            value: content,
        })
    }

    const handleNricChange = (value: string): void => {
        dispatch({
            type: ActionType.ADD_PERSONAL_DETAILS,
            value: {
                ...state.personalDetail,
                nric: value,
            },
        })
    }

    const handleNameChange = (value: string): void => {
        setNameErrorMessage(validateName(value))
        setCardNameErrorMessage(validateCardName(value))
        const cleanedName = (value ?? ``)
            .replace(/[^A-Za-z ]/g, ``)
            .replace(/\s+/g, ` `)
            .trim()
        dispatch({
            type: ActionType.ADD_PERSONAL_DETAILS,
            value: {
                ...state.personalDetail,
                name: value,
                cardName: cleanedName.substring(0, MAX),
            },
        })
    }

    const handleCardNameChange = (value: string): void => {
        dispatch({
            type: ActionType.ADD_PERSONAL_DETAILS,
            value: {
                ...state.personalDetail,
                cardName: value,
            },
        })
    }

    const handleDateOfBirthChange = (date: Date | null): void => {
        dispatch({
            type: ActionType.ADD_PERSONAL_DETAILS,
            value: {
                ...state.personalDetail,
                dateOfBirth: date,
            },
        })
    }

    const handleMobileNumberChange = (value: string): void => {
        dispatch({
            type: ActionType.ADD_PERSONAL_DETAILS,
            value: {
                ...state.personalDetail,
                mobileNumber: value,
            },
        })
    }

    const handleEmailChange = (value: string): void => {
        dispatch({
            type: ActionType.ADD_PERSONAL_DETAILS,
            value: {
                ...state.personalDetail,
                email: value,
            },
        })
    }

    const handleRaceChange = (option: Option) => {
        dispatch({
            type: ActionType.ADD_PERSONAL_DETAILS,
            value: {
                ...state.personalDetail,
                race: option,
            },
        })
    }

    const handleMaritalStatusChange = (option: Option) => {
        dispatch({
            type: ActionType.ADD_PERSONAL_DETAILS,
            value: {
                ...state.personalDetail,
                maritalStatus: option,
            },
        })
    }

    const handleEducationalStatusChange = (option: Option) => {
        dispatch({
            type: ActionType.ADD_PERSONAL_DETAILS,
            value: {
                ...state.personalDetail,
                educationalStatus: option,
            },
        })
    }

    const handleResidentialStatusChange = (option: Option) => {
        dispatch({
            type: ActionType.ADD_PERSONAL_DETAILS,
            value: {
                ...state.personalDetail,
                residentialStatus: option,
            },
        })
    }

    const handleGenderChange = (value: string): void => {
        setGenderErrorMessage(validateGender(value))
        dispatch({
            type: ActionType.ADD_PERSONAL_DETAILS,
            value: {
                ...state.personalDetail,
                gender: value,
            },
        })
    }

    const handleGenerateMockData = (): void => {
        dispatch({
            type: ActionType.ADD_PERSONAL_DETAILS,
            value: {
                ...state.personalDetail,
                ...signupFormGenerator(),
            },
        })
    }

    return (
        <Grid container rowSpacing={1} columnSpacing={{ xs: `16px`, sm: `24px`, md: `24px`, lg: `40px` }}>
            <ErrorDialog open={dialog.display} content={t(dialog.content, { ns: `common` })} title={t(dialog.title, { ns: `common` })} onClose={closeHandler}>
                {dialog.primaryButton && <Grid item sm={6} xs={12}><Button onClick={() => handleDialogClick(dialog.primaryButton)} fullWidth variant="contained">{t(dialog.primaryButton, { ns: `common` })}</Button></Grid>}
                {dialog.secondaryButton && <Grid item sm={6} xs={12}><Button onClick={() => handleDialogClick(dialog.secondaryButton)} fullWidth>{t(dialog.secondaryButton, { ns: `common` })}</Button></Grid>}
            </ErrorDialog>
            <Grid item xs={12} sm={12} md={12} lg={12}>
                {alert && alert.display && <Alert severity="error">{t(alert.content)}</Alert>}
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <NricInputField handleChange={handleNricChange} errorText={nricErrorMessage} defaultValue={state.personalDetail.nric} isDisabled={disabledFields.nric} />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} />
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <NricNameInputField handleChange={handleNameChange} errorText={nameErrorMessage} defaultValue={state.personalDetail.name} isDisabled={disabledFields.name} />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <CardNameInputField handleChange={handleCardNameChange} errorText={cardNameErrorMessage} defaultValue={state.personalDetail.cardName} isDisabled={disabledFields.cardName} />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <DateOfBirthInputField handleChange={handleDateOfBirthChange} errorText={dateOfBirthErrorMessage} defaultValue={state.personalDetail.dateOfBirth} isDisabled={disabledFields.dateOfBirth} />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} />
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <GenderInputField handleChange={handleGenderChange} errorText={genderErrorMessage} defaultValue={state.personalDetail.gender} isDisabled={disabledFields.gender} myInfoSuccess={myInfoSuccess} />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} />
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <MobileNumberInputField handleChange={handleMobileNumberChange} errorText={mobileNumberErrorMessage} defaultValue={processMobileNumber(state.personalDetail.mobileNumber)} isDisabled={disabledFields.mobileNumber} />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <EmailInputField handleChange={handleEmailChange} errorText={emailErrorMessage} defaultValue={state.personalDetail.email} isDisabled={disabledFields.email} />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <ResidentialStatusSelectField handleChange={handleResidentialStatusChange} errorText={residentialStatusErrorMessage} defaultValue={state.personalDetail.residentialStatus} dependentField={state.personalDetail.nric} />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <RaceSelectField handleChange={handleRaceChange} errorText={raceErrorMessage} defaultValue={state.personalDetail.race} isDisabled={disabledFields.race} />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <MaritalStatusSelectField handleChange={handleMaritalStatusChange} errorText={maritalStatusErrorMessage} defaultValue={state.personalDetail.maritalStatus} isDisabled={disabledFields.maritalStatus} />
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6}>
                <EducationSelectField handleChange={handleEducationalStatusChange} errorText={validEducationalErrirStatus} defaultValue={state.personalDetail.educationalStatus} isDisabled={disabledFields.educationalStatus} />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
                <Alert severity="info">
                    {t(`info`, { ns: `signup` })}
                </Alert>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} textAlign="center">
                <Button onClick={handleNavigateBack} variant="contained" color="secondary" size="large">
                    {t(`cancel_application`, { ns: `common` })}
                </Button>
            </Grid>
            <Grid item xs={12} sm={12} md={6} lg={6} textAlign="center">
                <SaveAndContinueButton loading={isLoading} onClick={handleSaveAndContinueClick} />
            </Grid>

            {process.env.NODE_ENV == `development` &&
                <Grid item xs={12} sm={12} md={12} lg={12} textAlign="center">
                    <Button variant="outlined" color="success" size="large" onClick={handleGenerateMockData}>
                        Fill up with fake data
                    </Button>
                </Grid>
            }
        </Grid>
    )
}

export default PersonalAndContactDetails
